<template>
	<transition :name="`notification-${position}`">
		<div v-show="show" class="note">
			<div class="box-toggle" @click="() => (show = false)">
				<div class="circle">
					<font-awesome-icon icon="fas fa-xmark" size="1x" />
				</div>
			</div>
			<div class="note-body">
				<div v-if="note.icon" class="note-icon">
					<font-awesome-icon :icon="`fal fa-${note.icon}`" size="1x" />
				</div>
				<div class="note-content">
					<p>{{ note.content }}</p>
					<a
						v-if="note.link && note.button"
						target="_blank"
						:href="note.link"
						class="button-no-fill button-compact button-extra-compact"
					>
						{{ note.button }}
					</a>
				</div>
			</div>
		</div>
	</transition>
</template>

<script setup>
import getTrigger from '@becurioushq/conversiontriggers';

const props = defineProps({
	note: { type: Object, default: () => {} },
	trigger: { type: String, default: '' },
	id: { type: Number, default: 0 },
	position: { type: String, default: '' },
});

const show = ref(false);

onMounted(async () => {
	if (window.sessionStorage.getItem(`displayed-notification-${props.id.toString()}`)) {
		return;
	}

	const showNotification = await getTrigger(props.trigger);
	show.value = await showNotification(props.id);

	window.sessionStorage.setItem(`displayed-notification-${props.id.toString()}`, 'true');
});
</script>

<style>
.note-wrapper:nth-child(3) .note.notification-right-enter-active,
.note-wrapper:nth-child(3) .note.notification-left-enter-active {
	transition-delay: 1s;
}

.note-wrapper:nth-child(2) .note.notification-right-enter-active,
.note-wrapper:nth-child(2) .note.notification-left-enter-active {
	transition-delay: 3s;
}

.note-wrapper:nth-child(1) .note.notification-right-enter-active,
.note-wrapper:nth-child(1) .note.notification-left-enter-active {
	transition-delay: 6s;
}
</style>

<style lang="scss" scoped>
.notification-right-enter-active {
	transform: translate(150%, 0);
}

.notification-right-enter-to,
.notification-right-leave-to {
	transform: translate(150%, 0);
}

.notification-left-enter-active {
	transform: translate(-150%, 0);
}

.notification-left-enter-to,
.notification-left-leave-to {
	transform: translate(-150%, 0);
}

.note {
	width: 100%;
	z-index: 88888;
	transition: all 0.3s ease;
	margin-bottom: 22px;
	box-shadow: 0 0 4px 1px rgb(0 0 0 / 15%);
	font-size: 14px;
	position: relative;
	padding: 22px 30px 20px 20px;
	background: var(--cta-color);
	color: #fff;

	.box-toggle {
		padding: 0;
		background: transparent;
	}

	.note-body {
		display: flex;
		flex-flow: row nowrap;
		align-items: center;

		p {
			margin: 0;
			line-height: 24px;
		}

		.note-icon {
			min-width: 30px;
			font-size: 22px;
			text-align: center;
			margin-right: 12px;
		}
	}

	:deep(h1),
	:deep(h2),
	:deep(h3),
	:deep(h4) {
		font-family: proxima-nova, sans-serif;
		font-size: 14px;
		font-weight: bold;
	}

	:deep(p) {
		margin: 5px 0;
	}

	.button-no-fill {
		color: #fff;
		border-color: #fff;
	}

	.circle {
		cursor: pointer;
		position: absolute;
		right: 15px;
		top: -15px;
		background: var(--alternating-background-color);
		box-shadow: 0 0 4px 1px rgb(0 0 0 / 15%);
		color: #000;
		height: 30px;
		vertical-align: middle;
		width: 30px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 13px;
	}
}
</style>
